// React
import React, { Fragment } from "react";
import PropTypes from "prop-types";

// Libs
import { Row, Col } from "react-bootstrap";

// Images
import earningPurpleCard from "../../images/earning-purple-card.svg";
import earningOrangeCard from "../../images/earning-orange-card.svg";
import earningGreenCard from "../../images/earning-green-card.svg";

// Style
import "./Earnings.css";

const Earnings = ({ earnings }) => {
  const earningCards = {
    total_sales_formatted: { image: earningPurpleCard, text: "Total Sales" },
    total_cost_formatted: {
      image: earningOrangeCard,
      text: (
        <Fragment>
          Total Cost <span>(Paid to Supplier)</span>
        </Fragment>
      )
    },
    total_profit_formatted: { image: earningGreenCard, text: "Total Profit" }
  };

  return (
    <Fragment>
      <Row>
        {Object.keys(earnings.formatted_totals).map((total, index) => {
          return (
            <Col md={4} lg={4} key={index}>
              <div className="earnings__card">
                <div className="earnings__card-container">
                  <img
                    src={earningCards[total].image}
                    alt="Earning  Card"
                    className="earnings__card"
                  />
                  <div className="earnings__card-text">
                    <div>
                      {earnings.formatted_totals[total].substring(4)}{" "}
                      <span>{earnings.currency}</span>
                    </div>
                    <div>{earningCards[total].text}</div>
                  </div>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
    </Fragment>
  );
};

Earnings.propTypes = {
  earnings: PropTypes.object.isRequired
};

export default Earnings;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/financialDashboard/Earnings.js